import { jQuery as $ } from 'mk/jQuery';

function getDetailsUrl(sectionEl: HTMLElement) {
    return sectionEl.getAttribute('data-details-url');
}

let loadingShares: boolean = false;
function handleSharingUsersPopup(sectionEl) {
    if (loadingShares) {
        return;
    }

    loadingShares = true;
    const detailsUrl = getDetailsUrl(sectionEl);
    const $popup = $('.sharing-users-info-popup');
    if ($popup.attr('data-url') === detailsUrl) { // this item's window is already open, close it
        $popup.remove();
    } else {
        $popup.remove(); // remove any existing ones
        $.ajax({
            type: 'GET',
            url: detailsUrl,
            cache: false,
            dataType: 'text',
            success: (data) => {
                const newPopup = $(data).appendTo($('body'));

                newPopup.on('click', '.sharing-users-info-popup-close', (ev) => {
                    $(ev.currentTarget).closest('.sharing-users-info-popup').remove();
                })
                .css('left', ($(window).width() - newPopup.outerWidth()) / 2);

                $('.sharing-users-info-popup').attr('data-url', detailsUrl);
                loadingShares = false;
            },
            error: (XMLHttpRequest, textStatus, errorThrown) => {
                window.alert(`Cannot get sharing users, try later. Error: ${textStatus} ${errorThrown}`);
                loadingShares = false;
            },
        });
    }
 }

export function init() {
    $(document).on('click', 'button.sharing-users-info-button', (e) => {
        // this is general code, let's make it as safe as possible
        e.stopPropagation();
        const infobox = $(e.currentTarget).closest('.sharing-users-info-box')[0];
        handleSharingUsersPopup(infobox);
        return false;
    });
}
